import { ClinicalTrialInventoryState } from '@restore/clinicalTrialInventory/clinicalTrialInventory.types';
import { UserInfo } from '@components/UserInfo/UserInfo';
import {
  ClinicalTrialInventoryBaseType,
  ClinicalTrialInventoryInstrumentType,
  ClinicalTrialInventoryMeasurementType,
  ClinicalTrialInventoryReaderType,
} from '@dynamika-shared/types/clinicalTrialInventory';
import { TeamMember } from '@dynamika-shared/types/teamMember';
import * as yup from 'yup';
import { singular } from 'pluralize';
import { capitalize, startCase } from 'lodash';

export const getScoringFormById = (
  row:
    | ClinicalTrialInventoryMeasurementType
    | ClinicalTrialInventoryInstrumentType,
  clinicalTrialInventoryState: ClinicalTrialInventoryState
) => {
  const currentForm = clinicalTrialInventoryState.scoringForms.find(
    form => form.id === row.scoringFormId
  );
  return currentForm ? currentForm.name : row.scoringFormId;
};

export const getUserById = (
  row: ClinicalTrialInventoryReaderType,
  allTeamMembers: TeamMember[]
) => {
  const currentUser = allTeamMembers.find(
    member => member.id === row.dynamikaUserId
  );
  return currentUser ? (
    <UserInfo
      fullName={currentUser.fullName}
      enabled={currentUser.enabled}
      email={currentUser.email}
    />
  ) : (
    row.dynamikaUserId
  );
};

export const transformNameToSingle = <T extends string>(word: T): string => {
  return capitalize(singular(startCase(word)));
};

export const schemaInventoryItemBase = yup.object().shape({
  name: yup.string().required('Name is required').min(3),
  code: yup
    .string()
    .required('Code is required')
    .min(3, 'Code must be at least 3 characters')
    .matches(
      /^[A-Z0-9_]+$/,
      'Code must be in uppercase, contain numbers, and have no spaces'
    ),
  description: yup.string(),
});

export const sortClinicalTrialInventory =
  (sortState: string) =>
  (a: ClinicalTrialInventoryBaseType, b: ClinicalTrialInventoryBaseType) => {
    const [column, direction] = sortState.split(',');
    const key = column as keyof ClinicalTrialInventoryBaseType;
    if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
    if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
    return 0;
  };
